import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../shared/module/angular-material.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DynamicDialogComponent } from './dynamic-dialog.component';
import { BrowserModule } from '@angular/platform-browser';
import { SensorDialogComponent } from './sensor-dialog/sensor-dialog.component';
import { GridConfigDialogComponent } from './grid-config-dialog/grid-config-dialog.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapDialogModule } from './map-dialog/map-dialog.module';
import { ThresholdDialogComponent } from './threshold-dialog/threshold-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { AddMaintenanceDialogComponent } from './add-maintenance-dialog/add-maintenance-dialog.component';
import { AddPartDialogComponent } from './add-part-dialog/add-part-dialog.component';
import { MotorDialogComponent } from './motor-dialog/motor-dialog.component';
import { FleetModule } from '../fleet/fleet.module';
import { NewVehicleDialogComponent } from './new-vehicle-dialog/new-vehicle-dialog.component';
import { ApplicationPipesModule } from '../shared/module/applicationPipesModule';
import { AddPartVehicleDialogComponent } from './add-part-vehicle-dialog/add-part-vehicle-dialog.component';
import { AddPartOemReferenceDialogComponent } from './add-new-part-oem-reference-dialog/add-part-oem-reference-dialog.component';
import { BulkPartAddDialogModule } from './bulk-part-add-dialog/bulk-part-add-dialog.module';
import { AddPartByGroupDialogComponent } from './add-part-by-group-dialog/add-part-by-group-dialog.component';
import { VehicleGridModule } from '../fleet/vehicle-grid/vehicle-grid.module';
import { UpdateDateListDialogComponent } from './update-date-list-dialog/update-date-list-dialog.component';
import { AddUserDialogComponent } from './add-user-dialog/add-user-dialog.component';
import { SensorStatusModule } from '../fleet/vehicle-grid/sensor-status/sensor-status.module';
import { AddTenantDialogComponent } from './add-tenant-dialog/add-tenant-dialog/add-tenant-dialog.component';
import { AddModuleProviderDialogComponent } from './add-module-provider/add-module-provider-dialog.component';
import { SelectRoleComponent } from './select-role/select-role.component';
import { DropdownSearchableModule } from '../shared/dropdown-searchable/dropdown-searchable.module';
import { DropdownSearchableRenderedModule } from '../shared/dropdown-searchable-rendered/dropdown-searchable-rendered.module';
import { ThresholdSelectModule } from '../shared/threshold-select/threshold-select.module';
import { SelectGroupComponent } from './select-group/select-group.component';
import { DynamicTableModule } from '../dynamic-table/dynamic-table.module';
import { AttributeDialogComponent } from './attribute-dialog/attribute-dialog.component';
import { AttributeListModule } from '../shared/attribute-list/attribute-list.module';
import { UpdateVehicleLayoutDialogComponent } from './update-vehicle-layout-dialog/update-vehicle-layout-dialog.component';
import { MultiSelectModule } from '../shared/components/multi-select/multi-select.module';
import { DriverDialogComponent } from './driver-dialog/driver-dialog.component';
import { TosDialogComponent } from './tos-dialog/tos-dialog.component';
import { AddNewTelematicDeviceDialogComponent } from './add-new-telematic-device-dialog/add-new-telematic-device-dialog.component';
import { DynamicConfirmDialogComponent } from './dynamic-confirm-dialog/dynamic-confirm-dialog.component';
import { ManageMobileAccessComponent } from './manage-mobile-access/manage-mobile-access.component';
import { PrintFiguresDialogComponent } from 'src/app/dynamic-dialog/print-figures-dialog/print-figures-dialog.component';
import { FeatureSettingsDialogComponent } from './feature-settings-dialog/feature-settings-dialog.component';
import { AddSensorDialogComponent } from './add-sensor-dialog/add-sensor-dialog.component';
import { IconCardPickerComponent } from './add-sensor-dialog/icon-card-picker.component';


@NgModule({
  declarations: [
    DynamicDialogComponent,
    SensorDialogComponent,
    GridConfigDialogComponent,
    ThresholdDialogComponent,
    AddMaintenanceDialogComponent,
    AddPartDialogComponent,
    AddPartByGroupDialogComponent,
    MotorDialogComponent,
    NewVehicleDialogComponent,
    AddPartVehicleDialogComponent,
    AddPartOemReferenceDialogComponent,
    UpdateDateListDialogComponent,
    AddUserDialogComponent,
    AddTenantDialogComponent,
    AddModuleProviderDialogComponent,
    SelectRoleComponent,
    SelectGroupComponent,
    AttributeDialogComponent,
    UpdateVehicleLayoutDialogComponent,
    DriverDialogComponent,
    TosDialogComponent,
    AddNewTelematicDeviceDialogComponent,
    DynamicConfirmDialogComponent,
    ManageMobileAccessComponent,
    PrintFiguresDialogComponent,
    FeatureSettingsDialogComponent,
    AddSensorDialogComponent,
    IconCardPickerComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressBarModule,
    MatPaginatorModule,
    ApplicationPipesModule,
    GoogleMapsModule,
    MapDialogModule,
    BulkPartAddDialogModule,
    TranslateModule,
    FleetModule,
    VehicleGridModule,
    SensorStatusModule,
    DropdownSearchableModule,
    DropdownSearchableRenderedModule,
    ThresholdSelectModule,
    DynamicTableModule,
    AttributeListModule,
    MultiSelectModule
  ],
  exports: [
    DynamicDialogComponent,
    SensorDialogComponent,
    GridConfigDialogComponent,
    ThresholdDialogComponent,
    AddMaintenanceDialogComponent,
    AddPartDialogComponent,
    AddPartByGroupDialogComponent,
    MotorDialogComponent,
    NewVehicleDialogComponent,
    AddPartVehicleDialogComponent,
    AddPartOemReferenceDialogComponent,
    AddUserDialogComponent,
    AddModuleProviderDialogComponent,
    SelectRoleComponent,
    SelectGroupComponent,
    AttributeDialogComponent,
    UpdateVehicleLayoutDialogComponent,
    TosDialogComponent,
    AddNewTelematicDeviceDialogComponent,
    ManageMobileAccessComponent,
    PrintFiguresDialogComponent
  ]
})
export class DynamicDialogModule { }
